import { CustomButton } from "../../CustomButton";
import { useState } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import { campaignsApi, useDeleteAccountPlanMutation } from "../../../../api";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../types/enums";
import { useAppDispatch } from "../../../../hooks";

export const RemoveAccountPlanBtn = ({
  companyName,
  account_id,
  campaign_id,
}: {
  companyName: string;
  account_id: string;
  campaign_id: string;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [deleteAccountPlan, { isLoading }] = useDeleteAccountPlanMutation();

  const deleteAccountPlanHandler = () => {
    deleteAccountPlan({ id: account_id, campaign_id })
      .unwrap()
      .then(() => {
        dispatch(campaignsApi.util.invalidateTags(["summary"]));
        navigate(`${AppRoutes.ACCOUNT}/${campaign_id}/${account_id}`);
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Failed Delete Account Plan"}
          />,
        );
      });
    setIsOpen(false);
  };

  return (
    <>
      <CustomButton
        onClick={() => setIsOpen(true)}
        variant="contained"
        textColor="#FFFFFF"
        customColor="#C0392B"
        type="button"
        customSize={"fit"}
        sx={{ height: "38px" }}
        disabled={isLoading}
        startIcon={
          isLoading && <CircularProgress size={20} sx={{ color: "inherit" }} />
        }
      >
        Remove Account Plan
      </CustomButton>
      <ReuseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={deleteAccountPlanHandler}
        title="Remove Account Plan"
        customText={
          <Stack gap="32px">
            <Typography variant="body1" color="text.secondary">
              Are you sure you want to remove the account plan for {companyName}
              ?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You’ll need to generate it again if you need it later.
            </Typography>
          </Stack>
        }
        isDisabled={isLoading}
        isLoading={isLoading}
        submitBtnText="Remove"
        maxWidth="430px"
      />
    </>
  );
};
